<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData" />
                <div v-else>
                    <h4 class="text-error mb-2.5 font-normal">
                        {{ beforeApplyStatus ? '您已申請電子通知單服務' :'您尚未申請電子通知單服務' }}
                    </h4>
                    <div class="border-t border-gray-100 text-base mb-7 py-4 md:py-5">
                        <h4 class="text-secondary mb-2.5 font-bold">
                            請選擇欲變更之內容
                        </h4>
                        <Radio
                            v-if="applyOneById"
                            v-model:checked-value="selected"
                            value="3"
                            text="申請本保單"
                            class="mb-2.5 items-baseline"
                        />
                        <Radio
                            v-if="applyAllById"
                            v-model:checked-value="selected"
                            value="1"
                            text="申請本保單之要保人所投保之所有個人險有效及停效保單"
                            class="mb-2.5 items-baseline"
                        />
                        <!-- text="申請本保單之要保人所投保之所有個人險有效及停效保單(不包含MG系列保單)" -->
                        <Radio
                            v-if="cancelOneByPoly"
                            v-model:checked-value="selected"
                            value="4"
                            text="終止本保單"
                            class="mb-2.5 items-baseline"
                        />
                        <Radio
                            v-if="cancelAllById"
                            v-model:checked-value="selected"
                            value="2"
                            text="終止本保單之要保人所投保之所有個人險有效及停效保單"
                            class="mb-2.5 items-baseline"
                        />
                        <!-- text="終止本保單之要保人所投保之所有個人險有效及停效保單(不包含MG系列保單)" -->
                        <ul
                            v-if="cancelAllById || cancelOneByPoly"
                            class="text-tip md:mt-2"
                        >
                            <li>終止電子通知單服務，原電子化通知服務將改以書面寄送。</li>
                        </ul>
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar :control-visible="selected!==''">
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    v-model:isGetButtonInfo="isGetButtonInfo"
                    :disabled="selected===''"
                    @click="handleSubmit"
                />
            </template>
        </Bottombar>
        <Loading :is-loading="isLoading" />
        <PopupBase
            v-model:visiblePopup="visiblePopup"
            closeicon
            :params="{
                title: '重要提醒',
                isErrorButton: false,
                confirmButton: '確定',
                cancelButton: '我要變更',
                isDisabledButton: needEmailVerify && !isValid
            }"
            @cancel="addBC"
            @confirm="saveAndgoNext"
            @handleClose="visiblePopup=false"
        >
            <template #content>
                <p class="word-">
                    電子通知單將發送至要保人E-mail，請確認E-mail是否正確？
                </p>
                <p class="text-secondary my-5 break-all">
                    {{ email }}
                </p>
                <ValidEmailButton
                    v-model:propsValidEmail="propsValidEmail"
                    v-model:isValid="isValid"
                    :needEmailVerify="needEmailVerify"
                    :email="email"
                />
                <p class="pt-5 text-error">
                    電子信箱將一併更新至以您為要保人所投保之所有個人險有效及停效保單。
                    <!-- 電子信箱將一併更新至以您為要保人所投保之所有個人險(含MG系列保單)有效及停效保單。 -->
                </p>
                <p class="pt-5 text-error">
                    {{ errorMessage }}
                </p>
            </template>
        </PopupBase>
        <ValidEmail
            v-model:isValid="isValid"
            v-model:needEmailVerify="needEmailVerify"
            v-model:propsValidEmail="propsValidEmail"
            :inPopupBase="true"
            :email="email"
        />
    </div>
</template>

<script>
import { ref, reactive, toRefs, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getInfoB4, submitB4 } from '@/apis/B4';
// import { postTransactionItems } from '@/apis/system';
import PopupBase from '@/components/dialogs/Popup.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
// import { notification } from '@/utils/notification';
import Skeletons from './Skeletons.vue';
import { addAndInsertService } from '@/utils/changeItems/insertService';
import ValidEmail from '@/components/dialogs/ValidEmail.vue';
import ValidEmailButton from '@/components/buttons/ValidEmailButton.vue';

export default {
    components: {
        Bottombar,
        Loading,
        Radio,
        PopupBase,
        ButtonNextService,
        Skeletons,
        ValidEmail,
        ValidEmailButton,
    },
    setup() {
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const visiblePopup = ref(false);
        const isGetButtonInfo = ref(false);
        const isApply = ref(true);
        const isSubmitOk = ref(false);
        const isLoading = ref(false);
        const isGettingData = ref(false);
        const selected = ref('');
        const state = reactive({
            isValid: false,
            needEmailVerify: true,
            propsValidEmail: false,
            errorMessage: '',
        });

        const result = computed(() => store.state.services.changeItemsResult[code]);
        const data = reactive({
            email: '',
            applyAllById: false,
            applyOneById: false,
            beforeApplyStatus: false,
            cancelAllById: false,
            cancelOneByPoly: false,
        });

        // 取得api資料
        const getData = () => {
            isGettingData.value = true;
            getInfoB4().then((res) => {
                const keys = Object.keys(res.data);
                keys.forEach(k => {
                    data[k] = res.data[k];
                });
            }).finally(() => {
                isGettingData.value = false;
            });
        };
        if (!result.value) {
            getData();
        } else {
            getData();
            const { selectVal } = result.value;
            selected.value = selectVal;
        }
        /** 檢查如果是value=1&&當次沒有變更BC，就必須打開燈箱請user確認email，如果點選我要變更按鈕，將前往地址電話變更流程 */
        const handleSubmit = () => {
            isLoading.value = true;
            submitB4(selected.value).then(() => {
                if (selected.value === '1' || selected.value === '3') {
                    // const transactionItems = store.state.services.transactionItems;
                    // const bcIndex = transactionItems.findIndex(i => i.transactionItemNo === 'BC' && i.userChecked);
                    // if (bcIndex === -1) {
                    visiblePopup.value = true;
                    // } else {
                    //     isSubmitOk.value = true;
                    // }
                } else {
                    isSubmitOk.value = true;
                }

                const value = {
                    dataAPI: data,
                    selectVal: selected.value,
                };
                store.dispatch('services/setChangeItemsResult', { code, value });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        const saveAndgoNext = () => {
            if (state.needEmailVerify && !state.isValid) {
                state.errorMessage = '請先進行驗證Email';
                return;
            }
            isSubmitOk.value = true;
        };

        const addBC = async () => {
            isLoading.value = true;
            await addAndInsertService(['BC', code], code);
            isLoading.value = false;
        };

        return {
            selected,
            isApply,
            isGetButtonInfo,
            isLoading,
            isGettingData,
            visiblePopup,
            saveAndgoNext,
            handleSubmit,
            ...toRefs(data),
            ...toRefs(state),
            addBC,
            isSubmitOk,
        };
    },
};
</script>
